import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import { environment } from '@env'
import { appConfig } from './app/app.config'
import { App } from './app/app'

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err))
